import {
  ChartPieIcon,
  BellIcon,
  DocumentTextIcon,
  TableIcon,
  ShieldCheckIcon,
  LightBulbIcon,
  DocumentIcon
} from '@heroicons/react/outline'
import { ClipboardCheckIcon, ClipboardListIcon, CurrencyDollarIcon, UploadIcon, UserIcon } from '@heroicons/react/solid'

export const menuConfig: any = [
  { id: 100, name: 'dashboard', path: '/dashboard', icon: ChartPieIcon, visible: false },
  // { id: 200, name: 'upload_jobs', path: '/upload', icon: UploadIcon, visible: false },
  { id: 1100, name: 'upload_jobs', path: '/upload', icon: UploadIcon, visible: false },
  { id: 1101, name: 'upload_customer_file', path: '/upload-customer', icon: DocumentTextIcon, visible: true },
  { id: 300, name: 'plan_management', path: '/plan', icon: ClipboardListIcon, visible: false },

  { id: 250, name: 'route_suggestions', path: '/route-suggestion', icon: LightBulbIcon, visible: false },
  { id: 1200, name: 'route_suggestions_v2', path: '/route-suggestion-v2', icon: LightBulbIcon, visible: false },
  // {
  //   id: 450, name: 'generate_documents', path: '', icon: DocumentIcon, visible: false,
  //   subMenu: [
  //     {
  //       id: 451, name: 'bill', path: '/requisition', visible: false
  //     }
  //   ]
  // },
  { id: 400, name: 'delivery_tracking', path: '/tracking', icon: ClipboardCheckIcon, visible: false },
  {
    id: 500, name: 'expenses', path: '', icon: CurrencyDollarIcon, visible: false,
    subMenu: [
      {
        id: 501, name: 'record_expenses', path: '/delivery-cost', visible: false
      },
      {
        id: 502, name: 'fleet_card', path: '/fleet-card', visible: false
      },
      {
        id: 503, name: 'oil_price', path: '/fuel-price', visible: false
      },
      {
        id: 504, name: 'set_shipping_costs', path: '/cost', visible: false
      }
    ]
  },
  // { id: 600, name: 'maintenance', path: '/maintanance', icon: CurrencyDollarIcon, visible: false },
  {
    id: 700, name: 'reports', path: '/reports', icon: DocumentTextIcon, visible: false,
    subMenu: [
      {
        id: 701, name: 'general_report', path: '/reports', visible: false
      }
      // {
      //   id: 702, name: 'temperature_report', path: '/temperature', visible: false
      // }
    ]
  },
  // { id: 800, name: 'notifications', path: '/alert', icon: BellIcon, visible: false },
  {
    id: 900, name: 'master_data', path: '', icon: TableIcon, visible: false,
    subMenu: [
      {
        id: 917, name: 'customer', path: '/customer', visible: false
      },
      {
        id: 915, name: 'warehouse_branch', path: '/shippoint', visible: false
      },
      {
        id: 919, name: 'delivery_to_destination', path: '/ship-to', visible: false
      },
      {
        id: 909, name: 'product_group', path: '/product-group', visible: false
      },
      {
        id: 908, name: 'product_type', path: '/product-type', visible: false
      },
      {
        id: 910, name: 'product_unit', path: '/product-unit', visible: false
      },
      {
        id: 907, name: 'product', path: '/product', visible: false
      },
      {
        id: 918, name: 'job_type', path: '/job-type', visible: false
      },
      {
        id: 912, name: 'car_type', path: '/vehicle-type', visible: false
      },
      {
        id: 911, name: 'car', path: '/vehicle', visible: false
      },
      {
        id: 901, name: 'subcontractor', path: '/subcontract', visible: false
      },
      {
        id: 902, name: 'driver', path: '/driver', visible: false
      },
      {
        id: 903, name: 'device_registration', path: '/device', visible: false
      },
      {
        id: 927, name: 'set_transportation_rate', path: '/price', visible: false
      },
      {
        id: 920, name: 'photo_settings', path: '/picture', visible: false
      },
      {
        id: 924, name: 'reason_for_increase', path: '/cause-of-product', visible: false
      },
      // {
      //   id: 904, name: 'garage', path: '/Garage', visible: false
      // },
      // {
      //   id: 905, name: 'maintenance_type', path: '/maintenance-type', visible: false
      // },
      // {
      //   id: 906, name: 'maintenance_type_vehicle', path: '/maintenance-type-unit', visible: false
      // },
      // {
      //   id: 913, name: 'fuel_type', path: '/fuel-type', visible: false
      // },
      {
        id: 914, name: 'expense_type', path: '/cost-type', visible: false
      },

      {
        id: 916, name: 'delivery_zone', path: '/zone', visible: false
      },
      // {
      //   id: 921, name: 'Customer User', path: '/customer-user', visible: false
      // },
      // {
      //   id: 922, name: 'root_cause_reason', path: '/cause-reason', visible: false
      // },
      // {
      //   id: 923, name: 'score', path: '/rating', visible: false
      // },

      {
        id: 925, name: 'document', path: '/documents', visible: false
      },

      {
        id: 928, name: 'transportation_revenu', path: '/price-model', visible: false
      },
      // {
      //   id: 929, name: 'holiday_calendar', path: '/calendar', visible: false
      // }
      {
        id: 930, name: 'center', path: '/center', visible: false
      },
    ]
  },
  {
    id: 1000, name: 'user_management', path: '', icon: ShieldCheckIcon, visible: false,
    subMenu: [
      {
        id: 1001, name: 'user_groups', path: '/user-group', visible: false
      },
      {
        id: 1002, name: 'users', path: '/users', visible: false
      },
      {
        id: 1003, name: 'set_permissions', path: '/roles', visible: false
      },
      {
        id: 1004, name: 'check_log_mobile', path: '/mobile-log', visible: false
      }
    ]
  },
  // { id: 1100, name: 'register', path: '/register', icon: UserIcon, visible: false },
]